<form
  #missingForm="ngForm"
  (ngSubmit)="submit()"
  novalidate>
  <div class="modal-header">
    <h4 class="modal-title">Update your pet status</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
    </button>
  </div>
  <div class="modal-body">
    <p>
      We understand having a pet missing is extremely distressing.
    </p>
    <p>
      If <strong>{{ petName }}</strong> is missing, please update their status accordingly.
    </p>
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <label class="form-label" for="type">
            Status:
          </label>
          <select
            #type="ngModel"
            class="form-control form-select"
            id="status"
            name="status"
            [(ngModel)]="selected">
            <option *ngFor="let status of statuses" [ngValue]="status.value">
              {{ status.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger text-white" ngbAutofocus (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button type="submit" class="btn btn-success text-white">
      Confirm
    </button>
  </div>
</form>
